import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';

export const GetUserBalanceSchema = z.object({
  user_id: z.string().min(1, {
    message: 'id user tidak boleh kosong!',
  }),
});
export type GetUserBalancePayload = z.infer<typeof GetUserBalanceSchema>;

export interface UserBalance {
  id_balance: number;
  balance: number;
  total_earned: number;
  total_withdrawn: number;
}

export type GetUserBalanceResponse = ApiResponse<UserBalance>;

export const getUserBalance = async (
  payload: GetUserBalancePayload
): Promise<GetUserBalanceResponse> => {
  const { user_id } = payload;
  const url = `user/${user_id}/balance`;

  return await apiClient.get(url);
};

export const GET_USER_BALANCE_QUERY_KEY = 'user-balance';
export function getUserBalanceQueryOptions(payload: GetUserBalancePayload) {
  return queryOptions({
    queryKey: [GET_USER_BALANCE_QUERY_KEY, payload.user_id],
    queryFn: () => getUserBalance(payload),
  });
}
